export default __webpack_public_path__ + "img/e2b06285356a1f75d8e8c772451c03cf.svg";